<template>
  <v-dialog v-model="showWelcomeDialog" persistent width="500">
    <v-card>
      <v-card-title class="title" primary-title
        >Velkommen til {{ appTitle }}
      </v-card-title>
      <v-card-text
        >{{ welcomeText }}
        <v-checkbox
          v-model="hideWelcomeDialogNextTime"
          color="primary"
          label="Ikke vis denne meldingen igjen."
        ></v-checkbox>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-btn flat color="primary" @click="showGuide">Vis guide</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click="closeDialog">Lukk</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "TheWelcomeDialog",
  data: () => ({
    hideWelcomeDialogNextTime: false,
    welcomeText:
      "Vi anbefaler alle nye brukere å se en kort guide som beskriver den viktigste funksjonaliteten i denne løsningen. Dette tar bare noen minutter. Klikk på 'Vis guide' under for å starte guiden, eller klikk 'Lukk' for å gå rett til kartet."
  }),
  computed: {
    ...mapState(["appTitle", "hideWelcomeDialog"]),
    hideWelcomeDialog: {
      set(hideWelcomeDialog) {
        this.setHideWelcomeDialog(hideWelcomeDialog);
      },
      get() {
        return this.$store.state.hideWelcomeDialog;
      }
    },
    showWelcomeDialog() {
      return !this.hideWelcomeDialog;
    }
  },
  methods: {
    ...mapActions(["setGuideIsRunning", "setHideWelcomeDialog"]),
    closeDialog: function() {
      if (this.hideWelcomeDialogNextTime) {
        localStorage.setItem("hideWelcomeDialog", JSON.stringify(true));
      }
      this.hideWelcomeDialog = true;
    },
    openDialog: function() {
      this.hideWelcomeDialog = false;
    },
    showGuide: function() {
      this.closeDialog();
      this.$tours["myTour"].start();
      this.setGuideIsRunning(true);
    }
  }
};
</script>

<style></style>
